import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Button, Col, Form } from 'react-bootstrap';
// import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Field, reduxForm } from 'redux-form';
import FieldInput from '../../../components/FieldInput';
import FieldInputArea from '../../../components/FieldInputArea';
import FieldInputChange from '../../../components/FieldInputChange';
import FieldInputDate from '../../../components/FieldInputDate';
import FieldInputMask from '../../../components/FieldInputMask';
import BootstrapTable from 'react-bootstrap-table-next';
import { formatarValorNormal } from '../../../utils/utils'



export const FormPesagem = ({ handleSubmit,
    pristine,
    reset,
    submitting,
    heading,
    leitura,
    handleSave,
    handleCancel,
    handleClickCapturaPesagem,
    motoristas,
    agricultores,
    produtos,
    tiposServicos,
    tiposPagamentos,
    handleChangeStatePesagem,
    pesagemState,
    handleDesativarPesagem

}) => {

    const options = {
        sortIndicator: true,
        noDataText: 'Sem dados'
    };

    const currencyConfig = {
        locale: "pt-BR",
        formats: {
            number: {
                BRL: {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                },
            },
        },
    };

    let autoComplete;
    let inputValorAdicionalServico;

    const isSaida = (pesagemState.id && pesagemState.id > 0);
    const campoData = (isSaida) ? "data_saida" : "data_entrada";
    const labelData = (isSaida) ? "Data Saída" : "Data Entrada";
    const nameValorTotalServico = (isSaida) ? "valor_total" : "valor";
    const nameValorTotalAdicionalServico = (isSaida) ? "valor_adicional" : "valorAdicionalServico";
    const actionsFormatter = (cell, row, obj) => {
        let acoes = <div>

            <Button disabled={isSaida} variant={isSaida ? 'secondary' : 'danger'} title="Excluir" size="sm" onClick={() => {
                let servicos = pesagemState.servicos ? pesagemState.servicos : [];
                servicos = servicos.filter((servico) => servico.id != row.id)
                atualizarServicos(servicos)

            }}> <span className="fa fa-trash" /> </Button>

            &nbsp;
                    </div>
        return acoes;
    };

    function atualizarTroco(value, valorTotalPesagem) {

        let valorPago = 0;
        if (value && value >= valorTotalPesagem) {
            valorPago = parseFloat(value);
            valorPago -= valorTotalPesagem;
        }
        valorPago = valorPago.toFixed(2)
        handleChangeStatePesagem("valorTroco", valorPago);
    }
    function somar(a, b) {
        return (!isNaN(a - b)) ? a + b : a;
    }

    let atualizarServicos = (servicos) => {
        handleChangeStatePesagem("servicos", servicos);
        handleChangeStatePesagem("valorTotalServico", null);
        handleChangeStatePesagem("descricao", null);
        handleChangeStatePesagem("valorAdicionalServico", null);
        handleChangeStatePesagem("tipoServico", null);
        let valorTotalServicos = 0;
        if (servicos && servicos.length > 0) {
            valorTotalServicos = servicos.map((s) => parseFloat(s.valor) + parseFloat(s.valorAdicionalServico)).reduce(somar)
        }
        console.log(valorTotalServicos);
        // valorTotalServicos += parseFloat(servico.valor) + servico.valorAdicionalServico;
        handleChangeStatePesagem("valorTotalServicos", valorTotalServicos);

        let valorTotalPesagem = (pesagemState.valorAdicionalPesagem) ? parseFloat(pesagemState.valorAdicionalPesagem) : 0;
        valorTotalPesagem += valorTotalServicos;
        handleChangeStatePesagem("valorTotalPesagem", valorTotalPesagem);
        atualizarTroco(pesagemState.valorPago, valorTotalPesagem)



    }
    const columns = [{
        dataField: 'id',
        text: 'ID',
        sort: true,
    }, {
        dataField: 'descricao',
        text: 'Descricao',
        sort: true,
    },
    {
        dataField: nameValorTotalServico,
        text: 'Valor Total',

    },
    {
        dataField: nameValorTotalAdicionalServico,
        text: 'Valor Adicional',
    },
    {
        text: 'Opções',
        formatter: actionsFormatter,
    }
    ];
    return <Form onSubmit={handleSubmit(handleSave)}>
        {!isSaida ?
            <Form.Row className="text-md-right" style={{ marginBottom: '3rem' }}>
                <Form.Group as={Col}  >

                    <Button disabled={submitting} onClick={() => {
                        handleChangeStatePesagem("avulsa", !pesagemState.avulsa);

                    }} variant={pesagemState.avulsa ? 'success' : 'danger'}><strong> {!pesagemState.avulsa ? 'REALIZAR PESAGEM AVULSA' : 'VOLTAR A PESAGEM PADRÃO'}</strong></Button>

                </Form.Group>
            </Form.Row>
            : <></>
        }
        {!pesagemState.avulsa ?
            <>

                <Form.Row className="text-md-center">
                    <Form.Group as={Col}  >

                        <Button size="lg" block disabled={submitting} onClick={handleClickCapturaPesagem} variant="info"><strong>REALIZAR CAPTURA DO PESO DA BALANÇA</strong></Button>

                    </Form.Group>
                </Form.Row>

                <Form.Row className="text-md-center">
                    <Form.Group as={Col}>
                        <Alert name="peso_capturado" variant="info">
                            <p><strong> Peso atual da balança</strong></p>
                            <h1 >{leitura && leitura > 0 ? formatarValorNormal(leitura) : 0} Kg</h1>
                        </Alert>
                    </Form.Group>
                </Form.Row></>
            :
            <>
                <Form.Row className="justify-content-md-center text-md-center">
                    <Col md="4">
                        <h1>Peso</h1>
                        <Form.Group >

                            <Field
                                TypeOf={Form.Control}
                                id="peso"
                                type="number"
                                name="peso"
                                size="lg"
                                isDisabled={isSaida}
                                placeholder="Informa o peso em números inteiros"
                                handleChange={(event) => handleChangeStatePesagem("peso", event.target.value)}
                                component={FieldInput}
                            />
                        </Form.Group>
                    </Col>
                </Form.Row>

            </>
        }
        <hr />
        <Form.Row>

            <Form.Group as={Col}>

                <Field
                    name={campoData}
                    label={labelData}
                    handleChange={(date) => handleChangeStatePesagem(campoData, date)}
                    defaultDate={pesagemState[campoData]}
                    component={FieldInputDate}
                />
            </Form.Group>

            <Form.Group as={Col}>

                <Field
                    TypeOf={Form.Control}
                    id="placa_carro"
                    type="text"
                    name="placa_carro"
                    label="Placa"
                    isDisabled={isSaida}
                    placeholder="Placa"
                    handleChange={(event) => handleChangeStatePesagem("placa_carro", event.target.value.toUpperCase())}
                    component={FieldInput}
                />
            </Form.Group>

            <Form.Group as={Col}>

                <Field
                    TypeOf={Form.Control}
                    id="nome_motorista"
                    type="text"
                    name="nome_motorista"
                    label="Motorista"
                    isDisabled={isSaida}
                    placeholder="Motorista"
                    handleChange={(event) => handleChangeStatePesagem("nome_motorista", event.target.value.toUpperCase())}
                    component={FieldInput}
                />
            </Form.Group>
        </Form.Row>

        <Form.Row>
            <Form.Group as={Col}>
                <Field
                    TypeOf={Typeahead}
                    type="text"
                    name="motorista"
                    label="Transportadora"
                    placeholder="Transportadora"
                    labelKey={option => `${option.nome_completo} ${option.transportadora ? ' - ' + option.transportadora : ''} `}
                    options={motoristas}
                    isDisabled={isSaida}
                    // handleChange={handleChangeVinculoTransporte}
                    selected={pesagemState.motorista ? [pesagemState.motorista] : ""}
                    handleChange={(options) => handleChangeStatePesagem("motorista", options[0])}
                    component={FieldInputChange}
                />
            </Form.Group>

            <Form.Group as={Col}>
                <Field
                    TypeOf={Typeahead}
                    type="text"
                    name="agricultor"
                    label="Agricultor/Fazenda"
                    placeholder="Agricultor/Fazenda"
                    labelKey={option => option && option.nome ? `${option.nome_completo} ${option.fazenda ? ' - ' + option.fazenda : ''}` : ''}
                    options={agricultores}
                    isDisabled={isSaida}
                    selected={pesagemState.agricultor ? [pesagemState.agricultor] : ""}
                    // handleChange={handleChangeFazenda}
                    handleChange={(options) => { handleChangeStatePesagem("agricultor", options[0]); }}
                    component={FieldInputChange}
                />
            </Form.Group>

        </Form.Row>

        <Form.Row>
            <Form.Group as={Col}>
                <Field
                    TypeOf={Typeahead}
                    type="text"
                    name="produto"
                    label="Produto"
                    placeholder="Produto"
                    labelKey={option => option && option.tipo_produto ? `${option.tipo_produto.descricao} - ${option.descricao}` : ''}
                    options={produtos}
                    isDisabled={isSaida}
                    selected={pesagemState.produto ? [pesagemState.produto] : ""}
                    // handleChange={handleChangeProduto}
                    handleChange={(options) => {
                        handleChangeStatePesagem("produto", options[0]);
                        // produtos = options
                    }}
                    component={FieldInputChange}
                />
            </Form.Group>
            <Form.Group as={Col}>
                <Field
                    type="text"
                    name="observacao"
                    label="Observação"
                    placeholder="Observação"
                    isDisabled={isSaida}
                    handleChange={(event) => handleChangeStatePesagem("observacao", event.target.value)}
                    component={FieldInputArea}
                />
            </Form.Group>
        </Form.Row>

        {(isSaida) ? <></> :
            <>
                <hr />
                <Form.Row>
                    <Col className="text-md-center">
                        <Alert variant="danger">
                            <h2>Serviços</h2>
                        </Alert>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Field
                            TypeOf={Typeahead}
                            type="text"
                            name="tipoServico"
                            label="Tipo de Serviço"
                            placeholder="Tipo de Serviço"
                            labelKey={option => `${option.descricao}`}
                            options={tiposServicos}
                            isDisabled={isSaida}
                            // handleChange={handleChangeTipoServico}
                            selected={pesagemState.tiposServicos ? [pesagemState.tiposServicos] : ""}
                            referencia={(typeahead) => autoComplete = typeahead}
                            handleChange={(options) => {
                                handleChangeStatePesagem("tipoServico", options[0]);
                                handleChangeStatePesagem("valorTotalServico", (options[0]) ? options[0].valor : "");
                                handleChangeStatePesagem("descricao", (options[0]) ? options[0].descricao : "");
                                handleChangeStatePesagem("valorAdicionalServico", null);
                            }}
                            component={FieldInputChange}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Field
                            TypeOf={Form.Control}
                            type="text"
                            name="descricao"
                            label="Descrição"
                            placeholder="Descrição"
                            isDisabled={isSaida}
                            handleChange={(event) => handleChangeStatePesagem("descricao", event.target.value)}
                            component={FieldInput}
                        />
                    </Form.Group>
                </Form.Row>



                <Form.Row >
                    <Form.Group as={Col}>
                        <Field
                            TypeOf={Form.Control}
                            id="valorTotalServico"
                            name="valorTotalServico"
                            type="text"
                            inputGrup="R$"
                            isDisabled={true}
                            label="Valor Total"
                            placeholder="0,00"
                            handleChange={(event) => handleChangeStatePesagem("valorTotalServico", event.target.value)}
                            component={FieldInput}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Field
                            name="valorAdicionalServico"
                            label="Valor Adicional"
                            isDisabled={isSaida}
                            maskInput={currencyConfig}
                            valorInicial={pesagemState.valorAdicionalServico}
                            referencia={(maskInputIntl) => inputValorAdicionalServico = maskInputIntl}
                            handleChange={(event, value, maskedValue) => {
                                handleChangeStatePesagem("valorAdicionalServico", value)
                            }}
                            component={FieldInputMask}
                        />
                    </Form.Group>

                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} className="text-md-right">
                        <Button
                            type='button'
                            // disabled={submitting}
                            variant="danger"
                            block
                            size="lg"
                            disabled={isSaida}
                            onClick={(event) => {
                                event.preventDefault();

                                let servicos = pesagemState.servicos ? pesagemState.servicos : [];

                                if (!pesagemState.tipoServico) {
                                    alert("Por favor, selecione um serviço!");
                                    return;
                                } else if (servicos.includes(pesagemState.tipoServico)) {
                                    alert("Serviço já adicionado!")
                                    return;
                                }

                                let servico = pesagemState.tipoServico;
                                servico.valorAdicionalServico = parseFloat(pesagemState.valorAdicionalServico ? pesagemState.valorAdicionalServico : 0);
                                servico.descricao = pesagemState.descricao;
                                servico.tipo_servico = pesagemState.tipoServico.id;
                                servico.valor_total = servico.valor
                                servico.valor_adicional = servico.valorAdicionalServico;
                                servicos.push(servico);

                                atualizarServicos(servicos)

                                inputValorAdicionalServico.setState({
                                    maskedValue: "R$ 0,00"
                                })

                                autoComplete.getInstance().clear();

                            }}>

                            <i className="fa fa-plus" aria-hidden="true" style={{ marginRight: '1rem' }} />

                            <b>ADICIONAR SERVIÇO</b>
                        </Button>
                    </Form.Group>
                </Form.Row></>}
        <Form.Row>
            <Form.Group as={Col} className="text-md-right">
                <BootstrapTable
                    striped hover condensed keyField='id' data={pesagemState.servicos ? pesagemState.servicos : ""} columns={columns} bordered={false} >


                </BootstrapTable>
            </Form.Group>
        </Form.Row>




        {isSaida ? <Form.Row /> :
            <>
                <hr />
                <Form.Row>
                    <Col className="text-md-center">
                        <Alert variant="success">
                            <h2>Valores</h2>
                        </Alert>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col}>

                        <Field
                            TypeOf={Typeahead}
                            type="text"
                            name="tipoPagamento"
                            label="Tipo de Pagamento"
                            placeholder="Tipo de Pagamento"
                            labelKey={option => `${option.descricao}`}
                            options={tiposPagamentos}
                            // handleChange={handleChangeTipoPagamento}
                            selected={pesagemState.tipoPagamento ? [pesagemState.tipoPagamento] : ""}
                            handleChange={(options) => handleChangeStatePesagem("tipoPagamento", options[0])}
                            component={FieldInputChange}
                        />
                    </Form.Group>

                    <Form.Group as={Col}>
                        <Field
                            name="valorPago"
                            label="Valor Pago"
                            maskInput={currencyConfig}
                            valorInicial={pesagemState.valorPago}
                            handleChange={(event, value, maskedValue) => {
                                handleChangeStatePesagem("valorPago", value)

                                let valorTotalPesagem = (pesagemState.valorTotalPesagem) ? parseFloat(pesagemState.valorTotalPesagem) : 0;
                                atualizarTroco(value, valorTotalPesagem)
                            }}
                            component={FieldInputMask}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Field
                            name="valorAdicionalPesagem"
                            label="Valor Adicional"
                            maskInput={currencyConfig}
                            valorInicial={pesagemState.valorAdicionalPesagem}
                            handleChange={(event, value, maskedValue) => {
                                handleChangeStatePesagem("valorAdicionalPesagem", value);
                                let valorTotalServicos = (pesagemState.valorTotalServicos) ? parseFloat(pesagemState.valorTotalServicos) : 0;
                                let valorAdicionalPesagem = (value) ? parseFloat(value) : 0;
                                valorTotalServicos += valorAdicionalPesagem;
                                handleChangeStatePesagem("valorTotalPesagem", valorTotalServicos);
                                atualizarTroco(pesagemState.valorPago, valorTotalServicos)
                            }}
                            component={FieldInputMask}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row >
                    <Form.Group as={Col}>
                        <Field
                            TypeOf={Form.Control}
                            type="text"
                            inputGrup="R$"
                            isDisabled={true}
                            name="valorTotalPesagem"
                            label="Valor Total"
                            placeholder="0,00"
                            handleChange={(event) => handleChangeStatePesagem("valorTotalPesagem", event.target.value)}
                            component={FieldInput}
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Field
                            TypeOf={Form.Control}
                            type="text"
                            isDisabled={true}
                            inputGrup="R$"
                            name="valorTotalServicos"
                            label="Valor Total Serviços"
                            placeholder="0,00"
                            handleChange={(event) => handleChangeStatePesagem("valorTotalServicos", event.target.value)}
                            component={FieldInput}
                        />
                    </Form.Group>


                    <Form.Group as={Col}>
                        <Field
                            TypeOf={Form.Control}
                            type="text"
                            inputGrup="R$"
                            isDisabled={true}
                            name="valorTroco"
                            label="Troco"
                            placeholder="0,00"
                            handleChange={(event) => handleChangeStatePesagem("valorTroco", event.target.value)}
                            component={FieldInput}
                        />
                    </Form.Group>

                </Form.Row>
            </>

        }

        <hr />
        <Form.Row>
            <Form.Group as={Col}>
                <Button disabled={submitting} onClick={() => handleCancel()} variant="danger" >Voltar</Button>
            </Form.Group>
            <Form.Group as={Col} className="text-md-right">
                <Button type="submit" disabled={submitting} variant="primary">Realizar Pesagem</Button>
            </Form.Group>
        </Form.Row>

    </Form >

};

const validate = values => {
    const errors = {};
    if (!values.tipoPagamento)
        errors.tipoPagamento = `Este campo é obrigatório.`;
    if (!values.valorPago || values.valorPago <= 0)
        errors.valorPago = `Este campo é obrigatório.`;
    if (!values.placa_carro || values.placa_carro <= 0)
        errors.placa_carro = `Este campo é obrigatório.`;
    if (!values.motorista)
        errors.motorista = 'Este campo é obrigatório';
    if (!values.agricultor)
        errors.agricultor = 'Este campo é obrigatório';
    if (!values.produto)
        errors.produto = 'Este campo é obrigatório';
    if (!values.nome_motorista)
        errors.nome_motorista = 'Este campo é obrigatório';

    // if (!values.valorTotalServicos){
    //     errors.tipoServico = `Adicione pelo menos um serviço.`;
    //     errors.valorTotalServicos = `Deve-se Adicionar pelo menos um serviço`;
    // }


    return errors;
};

FormPesagem.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    heading: PropTypes.string.isRequired,
    partidos: PropTypes.array.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    motoristas: PropTypes.array,
    agricultores: PropTypes.array,
    produtos: PropTypes.array,
    tiposServicos: PropTypes.array,
    tiposPagamentos: PropTypes.array,
    leitura: PropTypes.array,
    handleClickCapturaPesagem: PropTypes.func,
    handleDesativarPesagem: PropTypes.func,


};

export default reduxForm({
    form: 'FormPesagem',
    validate,
    enableReinitialize: true
})(FormPesagem);
